import React, { useState } from "react";
import ShepherdLogo from "../components/ShepherdLogo";

interface Props {
  onLogin: (email: string, password: string) => Promise<any>;
}

export default function LoginPage({ onLogin }: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await onLogin(email, password);
    } catch (err: any) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <section className="login-panel rise-in">
        <div className="login-aside">
          <div className="brand-block">
            <ShepherdLogo className="scale-[0.94] md:scale-100" />
          </div>
          <div className="eyebrow">Secure access</div>
          <h1 className="page-title page-title-serif">Elegant control for a dense operations workflow.</h1>
          <p className="page-copy">
            Sign in to access calls, orders, surveys, reporting, and management tools in the Shepherd operations workspace.
          </p>
          <div className="summary-list login-trust-list">
            <div className="summary-row">
              <span>Role-aware access</span>
              <strong>Protected</strong>
            </div>
            <div className="summary-row">
              <span>Calls, orders, reports</span>
              <strong>Unified</strong>
            </div>
            <div className="summary-row">
              <span>Management portal views</span>
              <strong>Included</strong>
            </div>
          </div>
        </div>

        <div className="login-form-panel">
          <div>
            <div className="eyebrow">Workspace sign-in</div>
            <h2 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950">Enter your account</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              Use your Shepherd credentials to continue into the workspace.
            </p>
          </div>

          {error && (
            <div className="mt-6 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}

          <form className="mt-8 space-y-5" onSubmit={handleSubmit}>
            <div>
              <label className="mb-2 block text-sm font-semibold text-slate-700">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-shell"
                placeholder="you@shepherd-assoc.com"
                required
              />
            </div>
            <div>
              <label className="mb-2 block text-sm font-semibold text-slate-700">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-shell"
                placeholder="Enter your password"
                required
              />
            </div>
            <button type="submit" disabled={loading} className="button-primary w-full !py-3">
              {loading ? "Signing in..." : "Enter workspace"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
